import siteConfig from '../siteConfig';
import brand from '../brand';

// Renders per-page <title>/<meta> tags. React 19 hoists these into <head>
// automatically wherever they're rendered in the tree, so no portal or
// head-management library (react-helmet, etc.) is needed.
//
// Canonical/OG URLs are always built from siteConfig.siteUrl (the VCS
// domain), never brand.domain — this app serves byte-identical pages on
// both the VCS and GRSC domains (see src/brand.js), so pinning canonical to
// one origin avoids search engines treating them as duplicate-content
// competitors. Only the *title* varies by brand.
export default function PageMeta({ title, description, image, path }) {
  const fullTitle = title ? `${title} | ${brand.siteName}` : brand.siteName;
  const url = path ? `${siteConfig.siteUrl}${path}` : siteConfig.siteUrl;

  return (
    <>
      <title>{fullTitle}</title>
      {description && <meta name="description" content={description} />}
      <link rel="canonical" href={url} />
      <meta property="og:title" content={fullTitle} />
      {description && <meta property="og:description" content={description} />}
      <meta property="og:url" content={url} />
      {image && <meta property="og:image" content={image} />}
      <meta name="twitter:title" content={fullTitle} />
      {description && <meta name="twitter:description" content={description} />}
      {image && <meta name="twitter:image" content={image} />}
    </>
  );
}
